const emojiQuiz = {
  sampleBotContent: {
    schemaVersion: 1,
    templateType: "emoji-quiz",
    items: [
      { id: "q1", question: "🎤☔ ", answers: ["singing in the rain"], image: null },
      { id: "q2", question: "🐍🐍✈️ ", answers: ["snakes on a plane"], image: null },
      { id: "q3", question: "👻🔫 ", answers: ["ghostbusters"], image: null },
      { id: "q4", question: "🐼👊 ", answers: ["kung fu panda"], image: null },
      { id: "q5", question: "🏃‍♂️📦🍫 ", answers: ["forrest gump"], image: null },
      { id: "q6", question: "🦁👑 ", answers: ["lion king"], image: null },
      { id: "q7", question: "🌊🦈 ", answers: ["jaws"], image: null },
      { id: "q8", question: "🕷️👨 ", answers: ["spiderman"], image: null },
      { id: "q9", question: "❄️🛳️ ", answers: ["titanic"], image: null },
      { id: "q10", question: "🤫🐑🐑 ", answers: ["silence of the lambs"], image: null },
      { id: "q11", question: "🪐🦍🦍 ", answers: ["planet of the apes"], image: null },
    ],
  },
  botId: "nualang.emoji-quiz.0.0.1",
  botName: "emoji_quiz",
  description: "emoji_quiz_desc",
  difficulty: "ALL",
  learnLang: "german",
  name: "Graf Dracula",
  botAvatar:
    "https://images.nualang.com/eyJidWNrZXQiOiJudWFsYW5nLWltYWdlcy1wcm9kIiwia2V5IjoiYXZhdGFycy8wLW51YWxhLTAwNi5wbmcifQ==",
  picture: `${process.env.REACT_APP_API}/image-creator/848/480/691f89/ffffff/fa-smile?fontSize=200`,
  creatorInstructions: "",
  studentInstructions: `# Willkommen zum Filmquiz
Gastgeber ist Graf Dracula.

Können Sie die vom Emoji dargestellten Filme nennen?
Einige zeigen den Filmtitel, andere die Handlung.

Sag "Hallo" zu Graf Dracula, um zu beginnen.`,
  voice: "Kasper",
  versionQuestion: "Wie viele Fragen möchten Sie in dieser Vorlage haben?",
};

export default emojiQuiz;
